export const buildTime = '2026-10-01 15:04:32 UTC';
